import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Divider, Box, Avatar, Stack, IconButton } from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import dayjs from 'dayjs';

const ExpensesDetails = ({ expense, onClose }) => {
    if (!expense)
        return <Typography variant="h6">Select a client to view details</Typography>;

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    };

    const tableHeaders = [
        { label: 'Field', width: '30%' },
        { label: 'Value', width: '70%' },
    ];

    const tableData = [
        ...(expense?.exp_pred ? [{
            field: 'Πρόβλεψη',
            value: <CheckIcon />
        }] : []),
        { field: 'Παραγωγή', value: expense?.prod_descr.p_descr },
        { field: 'Παραγωγή', value: expense?.pci_descr.pci_descr },
        { field: 'Αρ. Τιμολογίου', value: expense?.exp_inv_no },
        { field: 'Δικαιούχος', value: expense?.expense_beneficiaries_descr.eb_company_name },
        { field: 'Σύνολο', value: formatCurrency(expense?.exp_amount) },
        { field: 'Αρχείο', value: expense?.exp_original_filename },
        { field: 'Ημερομηνία τιμολογίου', value: expense?.exp_date ? dayjs(expense.exp_date).format('DD-MM-YYYY') : null },
        { field: 'Παρατηρήσεις', value: expense?.exp_notes },
        { field: 'Επεισόδια', value: Array.isArray(expense?.exp_assigned_episodes) ? expense.exp_assigned_episodes.join(', ') : '' }
    ];

    return (
        <Paper elevation={3} sx={{ padding: 2, borderRadius: 2, backgroundColor: '#f4f6f8', height: '100%' }}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                    {/* TITLE ? */}
                </Stack>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Stack>
            <Divider sx={{ marginBottom: 2 }} />
            <TableContainer component={Box}>
                <Table>
                    <TableBody>
                        {tableData.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>{row.field}</TableCell>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>{row.value}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default ExpensesDetails;